import { useCallback } from 'react';

export const useFilterToggle = (currentValues, updateFunction, filterKey) => {
  const isActive = useCallback(
    (value) => {
      return currentValues?.includes(value);
    },
    [currentValues]
  );

  const toggleFilter = useCallback(
    (value) => {
      const current = currentValues || [];
      const updated = current.includes(value) ? current.filter((item) => item !== value) : [...current, value];

      updateFunction({ [filterKey]: updated, page: 1 });
    },
    [currentValues, updateFunction, filterKey]
  );

  return { isActive, toggleFilter };
};

export const toggleMultipleFilter = (value, setStateFunction, filterKey) => {
  setStateFunction((prev) => {
    const current = prev[filterKey] || [];
    const updated = current.includes(value) ? current.filter((item) => item !== value) : [...current, value];
    return { ...prev, [filterKey]: updated };
  });
};

export const toggleSingleFilter = (value, setStateFunction, filterKey) => {
  setStateFunction((prev) => {
    const current = prev[filterKey];
    const updated = current === value ? '' : value;
    return { ...prev, [filterKey]: updated };
  });
};
